mod.modules.define("UserTips", function (fn) {

	var cookieName = "valueline_usertips";
	fn.prototype.cache = {
		$VisibleTip: null
	};

	fn.prototype.init = function (params) {
		var cookie = this.readCookie(cookieName);
		var CurrentTipNumber = 0;

		if(cookie == null) {
			this.createCookie(cookieName, 0, 10000);
		}else{
			CurrentTipNumber = parseInt(cookie);
		}
	
		this.cache.$VisibleTip = CurrentTipNumber;

		var Selector = "[data-usertip-number='" + CurrentTipNumber + "']";
		if(CurrentTipNumber < 5) {
			var CurrentTip = $(Selector);
			CurrentTip.fadeIn();
		}

		this.addEvents();
	};

	
		fn.prototype.addEvents = function () {
			var that = this;
			$("[data-usertip-number]").on(
				"mouseenter", 
				function (event) {
					event.stopPropagation();
					event.cancelBubble;
				}
			);

			$("[data-usertip-number]").on(
				"mouseleave", 
				function (event) {
					event.stopPropagation();
					event.cancelBubble;
				}
			);

			$(".security-banner-bars .banner-scroll-wrap").on(
				'click',
				function (event) {
					if(that.cache.$VisibleTip == 0) {
						that.transitionToTip(1);
					}
				}
			);

			$("#widget-com_templatedrawer").on(
				'mouseenter',
				function (event) {
					if(that.cache.$VisibleTip == 1) {
						that.transitionToTip(2);
					}
				}
			);

			$("[data-auto-symbol]").on(
				"click",
				function(event) {
					if(that.cache.$VisibleTip == 2) {
						that.transitionToTip(3);
					}					
				}
			);



			$("#widget-com_currentlistdrawerleft").on(
				'mouseenter',
				function (event) {
					if(that.cache.$VisibleTip == 3) {
						that.transitionToTip(4);
					}
				}
			);


			$("[data-action='usertip-next']").on('click', function (event) {
				// Scroll to the new index
				var $el = $(event.currentTarget);
				var nextTarget = parseInt($el.attr("data-usertip-next-target"));
				that.transitionToTip(nextTarget);
			});

			$(".closeAllUserTips").on('click', function(event) {
				$("[data-usertip-number]").fadeOut();

				that.eraseCookie(cookieName);
				that.createCookie(cookieName, 5, 10000);
				that.cache.$VisibleTip = 5;
			});

			$("[data-action='usertip-restart']").on('click', function (event) {
				that.transitionToTip(0);
			});

			$("[data-action='usertip-end']").on('click', function (event) {
				// Scroll to the new index
				var $el = $(event.currentTarget);
				var nextTarget = 0;
				
				var currentTip = $("[data-usertip-number='" + that.cache.$VisibleTip+ "']");
				currentTip.fadeOut();

				that.eraseCookie(cookieName);
				that.createCookie(cookieName, 5, 10000);
			});
			
		};

	fn.prototype.transitionToTip = function(tipIndex) {
		if(this.cache.$VisibleTip < 5) {
			var nextTarget = tipIndex;
		
			var currentTip = $("[data-usertip-number='" + this.cache.$VisibleTip+ "']");
			currentTip.fadeOut();

			this.cache.$VisibleTip = nextTarget;
			currentTip = $("[data-usertip-number='" + this.cache.$VisibleTip+ "']");
			currentTip.fadeIn();

			this.eraseCookie(cookieName);
			this.createCookie(cookieName, this.cache.$VisibleTip, 10000);
		}
	};

	fn.prototype.createCookie = function(name, value, days) {
		var expires = "";

		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toGMTString();
		} else {
			var expires = "";
		}

		document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
	};

	fn.prototype.readCookie = function(name) {
		var nameEQ = escape(name) + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return unescape(c.substring(nameEQ.length, c.length));
		}
		return null;
	};

	fn.prototype.eraseCookie = function(name) {
		this.createCookie(name, "", -1);
	};
});